import { thunk, action } from 'easy-peasy'
import Router from 'next/router'

import { getMe } from 'services/auth'

import { getCookie, removeCookie, setCookie } from 'utils/cookie'

const defaultToken = process.env.NEXT_PUBLIC_TOKEN_PUBLIC

const _states = {
  token: defaultToken,
  isLogin: false,
  isOpenLoginModal: false,
  profile: null,
  isChecked: false,
  customerStakeholder: null,
}

const _actions = {
  reset: action(() => {
    return {
      ..._states,
      isChecked: true,
    }
  }),
  setToken: action((state, payload) => {
    state.token = payload
  }),
  setOpenLoginModal: action((state, payload) => {
    state.isOpenLoginModal = payload
  }),
  setLogin: action((state, payload) => {
    state.isLogin = payload
  }),
  setProfile: action((state, payload) => {
    state.profile = payload
  }),
  setChecked: action((state, payload) => {
    state.isChecked = payload
  }),
  setCustomerStakeholder: action((state, payload) => {
    state.customerStakeholder = payload
  }),
}

const _thunks = {
  getProfile: thunk(async (actions, payload) => {
    const accessToken = payload || getCookie('accessToken')

    if (!accessToken) {
      actions.setChecked(true)
      return
    }

    actions.setToken(accessToken)

    const result = await getMe()
      .then(async res => {
        const profileData = res?.data?.data?.[0]

        actions.setProfile(profileData)
        actions.setLogin(true)
        actions.setChecked(true)

        setCookie('accessToken', accessToken)
      })
      .catch(async () => {
        removeCookie('accessToken')
      })

    actions.setChecked(true)

    return result
  }),

  logout: thunk(async (actions, payload, { getStoreActions }) => {
    Router.push('/')

    removeCookie('accessToken')

    getStoreActions().reset.resetUser()
  }),
}

const authModal = {
  ..._states,
  ..._actions,
  ..._thunks,
}

export default authModal
